function Lithuania({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1539)">
  <path d="M31.0048 21.5656C31.648 19.8324 32 17.9576 32 16.0004C32 14.0433 31.648 12.1685 31.0048 10.4353L16 9.04395L0.995188 10.4353C0.352 12.1685 0 14.0433 0 16.0004C0 17.9576 0.352 19.8324 0.995188 21.5656L16 22.9569L31.0048 21.5656Z" fill="#6DA544"/>
  <path d="M31.0049 10.4348C28.7442 4.342 22.8795 0 16 0C9.12061 0 3.25593 4.342 0.995239 10.4348H31.0049Z" fill="#FFDA44"/>
  <path d="M16 32.0002C22.8795 32.0002 28.7442 27.6582 31.0049 21.5654H0.995239C3.25593 27.6582 9.12061 32.0002 16 32.0002Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Lithuania;
